import { render, staticRenderFns } from "./ChicksByPostura.vue?vue&type=template&id=2c01e704&scoped=true"
import script from "./ChicksByPostura.vue?vue&type=script&lang=js"
export * from "./ChicksByPostura.vue?vue&type=script&lang=js"
import style0 from "./ChicksByPostura.vue?vue&type=style&index=0&id=2c01e704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c01e704",
  null
  
)

export default component.exports